export default "__VITE_ASSET__Q73kAdab__"